(() => {

    const HEADER = document.querySelector('.header')
    const SEARCH_BAR = document.querySelector('.header-desktop--search')
    const SEARCH_TRIGGER = document.querySelector('.header-desktop--search-trigger')

    if(!SEARCH_TRIGGER || !SEARCH_BAR || !HEADER) return

    const SEARCH_INNER = SEARCH_BAR.querySelector('.desktop--search-inner')


    SEARCH_TRIGGER.addEventListener('click', () => {

        const H = SEARCH_INNER.getBoundingClientRect().height
        const open = SEARCH_BAR.getBoundingClientRect().height > 0

        SEARCH_BAR.style = `max-height: ${ open ? 0 : H }px;`
        HEADER.classList.toggle('search')

        if(!open) {
            SEARCH_BAR.querySelector('input').focus()
        }
    })

})()
